import Link from "next/link";
import { useRouter } from "next/router";
import clsx from "clsx";
import useNavReloadOnActive from "./useNavReloadOnActive";

const isCurrent = (router, href) => {
  if (!href) return false;
  if (href === "/") return router.pathname === "/";
  return router.pathname === href || router.pathname.startsWith(`${href}/`);
};

const NavItem = ({ item, current, onActivate, onActiveClick }) => (
  <li className={clsx("site-nav__item", current && "is-current")}>
    <Link
      href={item.href}
      className="site-nav__link"
      aria-current={current ? "page" : undefined}
      onClick={(e) => {
        if (current) {
          // Re-tap on the active item → soft-reload the page so the user
          // sees fresh data without Next.js throwing a "same URL" warning.
          onActiveClick(e, item.href);
        }
        onActivate?.(e);
      }}
    >
      {item.label}
    </Link>
  </li>
);

const items = [
  { label: "Home", href: "/" },
  { label: "About Us", href: "/about" },
  { label: "Blog", href: "/blog" },
  { label: "Projects", href: "/projects" },
  { label: "Contact", href: "/contact" },
];

const NavMenu = ({ variant = "bar", onNavigate }) => {
  const router = useRouter();
  const isDrawer = variant === "drawer";
  const onActiveClick = useNavReloadOnActive();

  return (
    <ul className={clsx("site-nav", isDrawer && "site-nav--drawer")}>
      {items.map((item) => (
        <NavItem
          key={item.label}
          item={item}
          current={isCurrent(router, item.href)}
          onActivate={onNavigate}
          onActiveClick={onActiveClick}
        />
      ))}
    </ul>
  );
};

export default NavMenu;